var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-relative"},[_vm._t("default"),(_vm.show)?_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",value:(_vm.tooltip),expression:"tooltip",modifiers:{"hover":true}}],staticClass:"alert-icon",style:(_vm.position)},[_c('div',{staticClass:"parent"})]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }